export {
  mitrexPricingDetails,
  railingPriceTemplate,
  wallPriceTemplate,
  claddingPriceTemplate
}

const railingPriceTemplate = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Detailed pricing section title'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'SolaRail Detailed Pricing'
  },
  { 
    id: 'content',
    display: {
      component: 'DetailedPricingRailing',
      bind: {
        hasMpaPrice: true,
        hasDpaPrice: true
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Detailed pricing section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const wallPriceTemplate = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Detailed pricing section title'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'Solar Wall Detailed Pricing'
  },
  { 
    id: 'content',
    display: {
      component: 'DetailedPricingWall',
      bind: {
        hasMpaPrice: true,
        hasDpaPrice: true
      }
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Detailed pricing section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const claddingPriceTemplate = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Detailed pricing section title'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'Cladding Detailed Pricing'
  },
  { 
    id: 'content',
    display: {
      component: 'DetailedPricingCladding'
    },
    value: ''
  },
  { 
    id: 'desc',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Detailed pricing section description',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: ''
  }
]

const mitrexPricingDetails = {
  id: 'detailed_pricing',
  name: 'Detailed Pricing',
  type: 'pricing',
  subsections: []
}